import { useChildrenAsText } from '../../../utils/reactHelpers';

export const useController = ({ children: originalChildren }) => {
  const children = useChildrenAsText(originalChildren);

  return {
    children,
  };
};
